export const CREDITS_LIST_GET_CREDITS = "credits/list/CREDITS_LIST_GET_CREDITS";
export const CREDITS_LIST_GET_CREDITS_RESULT = "credits/list/CREDITS_LIST_GET_CREDITS_RESULT";